import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import {
  Badge,
  Card,
  Group,
  Loader,
  Stack,
  Text,
  TextInput,
} from "@mantine/core";
import toast from "react-hot-toast";

import { EmptyMessage } from "@components/shared";

export default function RoleList({ refresh = false }) {
  const { t } = useTranslation();
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchRoles();
  }, [refresh]);

  function fetchRoles() {
    setLoading(true);
    axios
      .get(`/roles/`)
      .then(({ data }) => {
        setRoles(data.response || []);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  const filtered = roles.filter((role) =>
    (role.name || "").toLowerCase().includes(search.toLowerCase().trim())
  );

  if (loading) {
    return (
      <Group justify="center" py="xl">
        <Loader size="sm" />
      </Group>
    );
  }

  return (
    <Stack gap="sm">
      <TextInput
        placeholder={String(t("search"))}
        size="lg"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      {!filtered.length && <EmptyMessage />}
      {filtered.map((role) => (
        <Card key={role.id} component={Link} to={`/roles/${role.id}`}>
          <Group justify="space-between">
            <Text c="dark" fw={700}>
              {role.name}
            </Text>
            <Badge variant="light" color="gray">
              {(role.permissions || []).length} {t("permission_plural")}
            </Badge>
          </Group>
        </Card>
      ))}
    </Stack>
  );
}
